import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function OfficeLocationSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div
        ref={ref}
        className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}
      >
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-semibold uppercase tracking-widest text-primary-600 bg-primary-100 rounded-full mb-4">
            Visit Us
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Our Office
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            Our headquarters is in Kochi — the heart of India's seafood and spice trade.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Office Card */}
          <div className="space-y-5">
            <div className="bg-card-50 shadow-sm border border-card-200 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-building-2-line text-lg"></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-foreground-950 text-sm">
                    Headquarters — Kochi
                  </h3>
                  <span className="text-xs text-accent-600 font-medium">
                    Main Office
                  </span>
                </div>
              </div>
              <address className="not-italic text-sm text-foreground-500 leading-relaxed space-y-1">
                <p>Freshhlock Technologies Pvt Ltd</p>
                <p>3rd Floor, Carnival Infopark Phase II</p>
                <p>Kakkanad, Kochi — 682 030</p>
                <p>Kerala, India</p>
              </address>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60">
                <a
                  href="mailto:hello@freshhlock.com"
                  className="flex items-center gap-1.5 text-xs text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line"></i>
                  hello@freshhlock.com
                </a>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="lg:col-span-2 bg-card-50 shadow-sm border border-card-200 rounded-xl overflow-hidden h-[420px] md:h-[500px] lg:h-auto">
            <iframe
              title="Freshhlock Headquarters — Kochi"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.0633091885423!2d76.36345!3d10.01305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080c3e2e7a5e3b%3A0x1a2b3c4d5e6f7a8b!2sInfopark%2C%20Kakkanad!5e0!3m2!1sen!2sin!4v1690000000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}